var _defs, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlaystore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Google_PlayStore",
    "data-name": "Google PlayStore",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#010101;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:url(#linear-gradient);}.cls-5{fill:url(#linear-gradient-2);}.cls-6{fill:url(#linear-gradient-3);}.cls-7{fill:url(#linear-gradient-4);}.cls-8,.cls-9{fill:#fff;}.cls-9{stroke:#fff;stroke-miterlimit:10;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID",
    className: "cls-1",
    d: "M110.72,68.87,88.13,55.82,44.55,30.66c-2.42-1.4-4.83-.55-4.83,2.37V135.55c0,2.19,1.72,3.13,3.83,1.92l44.58-25.75,22.59-13,21.72-12.54c2.55-1.47,2.3-3.49.15-4.65S110.72,68.87,110.72,68.87Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 67.71,
    y1: 28.27,
    x2: 67.71,
    y2: 139.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#287db0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#3d8fb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#74bcb9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8acebc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 39.72,
    y1: 55.82,
    x2: 110.72,
    y2: 55.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#53c0ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dee89a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 75.22,
    y1: 83.77,
    x2: 75.22,
    y2: 139.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb413d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#d64352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#9f4a89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#894c9e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 116.12,
    y1: 68.87,
    x2: 116.12,
    y2: 98.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f58879"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#fbb176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fec774"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M512,145.29A22.67,22.67,0,0,1,489.37,168H22.63A22.67,22.67,0,0,1,0,145.29V22.7A22.67,22.67,0,0,1,22.63,0H489.37A22.67,22.67,0,0,1,512,22.7Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PLAY"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "39.72 28.27 39.72 83.77 39.72 139.27 95.69 83.77 39.72 28.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "110.72 68.87 88.13 55.82 39.72 27.87 39.72 28.27 95.69 83.77 110.72 68.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "39.72 139.27 39.72 139.67 88.13 111.72 110.72 98.68 95.69 83.77 39.72 139.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "110.72 68.87 95.69 83.77 110.72 98.68 136.54 83.77 110.72 68.87"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M171.52,61.93h-4.59l-2.27-6.42h-9.91l-2.18,6.42H148l9.44-25.21h4.71Zm-8-9.83-3.5-10.05a11.55,11.55,0,0,1-.34-1.59h-.07a9.74,9.74,0,0,1-.35,1.59L155.84,52.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M190.56,61.93h-4.08V51.78q0-5-3.57-5a3.88,3.88,0,0,0-3.08,1.4,5.21,5.21,0,0,0-1.21,3.52V61.93h-4.09v-18h4.09v3h.07a6.42,6.42,0,0,1,5.84-3.41A5.44,5.44,0,0,1,189,45.41a8.57,8.57,0,0,1,1.55,5.51Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M211.9,61.93h-4.08V58.87h-.07a7,7,0,0,1-11.38,1.06,10,10,0,0,1-2-6.58,11,11,0,0,1,2.21-7.16,7.23,7.23,0,0,1,5.88-2.69,5.64,5.64,0,0,1,5.29,2.92h.07V35.28h4.08Zm-4-8.23V51.34a4.56,4.56,0,0,0-1.25-3.25,4.15,4.15,0,0,0-3.18-1.33,4.26,4.26,0,0,0-3.59,1.7,7.56,7.56,0,0,0-1.31,4.73,6.84,6.84,0,0,0,1.25,4.33,4.1,4.1,0,0,0,3.39,1.59,4.25,4.25,0,0,0,3.39-1.53A5.8,5.8,0,0,0,207.87,53.7Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M227.66,47.81a3.35,3.35,0,0,0-2.12-.58,3.66,3.66,0,0,0-3,1.64,7.36,7.36,0,0,0-1.21,4.44v8.62h-4.08v-18h4.08v3.71h.07a6.27,6.27,0,0,1,1.84-3A4.13,4.13,0,0,1,226,43.61a3.44,3.44,0,0,1,1.68.33Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M238.21,62.35a8.92,8.92,0,0,1-6.65-2.52,9.14,9.14,0,0,1-2.49-6.69,8.88,8.88,0,0,1,9.58-9.64A8.64,8.64,0,0,1,245.22,46a9.61,9.61,0,0,1,2.36,6.88,9.45,9.45,0,0,1-2.54,6.9A9.15,9.15,0,0,1,238.21,62.35Zm.19-15.59a4.65,4.65,0,0,0-3.78,1.67,7,7,0,0,0-1.38,4.6,6.64,6.64,0,0,0,1.4,4.46,4.73,4.73,0,0,0,3.76,1.62,4.46,4.46,0,0,0,3.7-1.6A7,7,0,0,0,243.4,53a7.15,7.15,0,0,0-1.3-4.59A4.47,4.47,0,0,0,238.4,46.76Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M253.79,40.15a2.49,2.49,0,0,1-1.72-.65,2.18,2.18,0,0,1-.71-1.66,2.23,2.23,0,0,1,.71-1.67,2.45,2.45,0,0,1,1.72-.66,2.49,2.49,0,0,1,1.75.66,2.2,2.2,0,0,1,.72,1.67,2.15,2.15,0,0,1-.72,1.63A2.46,2.46,0,0,1,253.79,40.15Zm2,21.78h-4.08v-18h4.08Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M277.5,61.93h-4.08V58.87h-.07A7,7,0,0,1,262,59.93a10,10,0,0,1-2-6.58,11,11,0,0,1,2.21-7.16,7.23,7.23,0,0,1,5.88-2.69,5.64,5.64,0,0,1,5.29,2.92h.07V35.28h4.08Zm-4-8.23V51.34a4.56,4.56,0,0,0-1.25-3.25A4.15,4.15,0,0,0,269,46.76a4.26,4.26,0,0,0-3.59,1.7,7.56,7.56,0,0,0-1.31,4.73,6.84,6.84,0,0,0,1.25,4.33,4.1,4.1,0,0,0,3.39,1.59,4.25,4.25,0,0,0,3.39-1.53A5.8,5.8,0,0,0,273.47,53.7Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M313.88,61.93H309.3L307,55.51h-9.91l-2.18,6.42h-4.57l9.43-25.21h4.72Zm-8-9.83-3.5-10.05a13.78,13.78,0,0,1-.33-1.59H302a10.93,10.93,0,0,1-.35,1.59L298.21,52.1Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M321,59.27H321V70.21h-4.08V43.93H321v3.16H321a6.68,6.68,0,0,1,6.12-3.59,6.46,6.46,0,0,1,5.34,2.41,10.09,10.09,0,0,1,1.92,6.47,11.19,11.19,0,0,1-2.17,7.21,7.16,7.16,0,0,1-5.9,2.71A5.89,5.89,0,0,1,321,59.27Zm-.11-7.1V54.4a4.74,4.74,0,0,0,1.26,3.34,4.12,4.12,0,0,0,3.19,1.37,4.18,4.18,0,0,0,3.56-1.76,8.23,8.23,0,0,0,1.29-4.93,6.5,6.5,0,0,0-1.2-4.16,4,4,0,0,0-3.26-1.5,4.4,4.4,0,0,0-3.51,1.54A5.76,5.76,0,0,0,320.93,52.17Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M342.73,59.27h-.07V70.21h-4.08V43.93h4.08v3.16h.07a6.68,6.68,0,0,1,6.12-3.59,6.46,6.46,0,0,1,5.34,2.41,10.09,10.09,0,0,1,1.92,6.47A11.24,11.24,0,0,1,354,59.59,7.18,7.18,0,0,1,348,62.3,5.89,5.89,0,0,1,342.73,59.27Zm-.11-7.1V54.4a4.74,4.74,0,0,0,1.26,3.34,4.12,4.12,0,0,0,3.19,1.37,4.18,4.18,0,0,0,3.56-1.76,8.23,8.23,0,0,0,1.29-4.93,6.5,6.5,0,0,0-1.2-4.16,4,4,0,0,0-3.26-1.5A4.41,4.41,0,0,0,344,48.3,5.76,5.76,0,0,0,342.62,52.17Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M381,62.35a11.31,11.31,0,0,1-8.73-3.54A12.93,12.93,0,0,1,369,49.62q0-6.07,3.34-9.7a11.72,11.72,0,0,1,9.07-3.62A11.08,11.08,0,0,1,390,39.81a13,13,0,0,1,3.24,9.2q0,6.16-3.32,9.75A11.51,11.51,0,0,1,381,62.35ZM381.21,40a7,7,0,0,0-5.63,2.59,10.2,10.2,0,0,0-2.18,6.8,10.38,10.38,0,0,0,2.11,6.77A6.81,6.81,0,0,0,381,58.69a7.13,7.13,0,0,0,5.72-2.44,10.22,10.22,0,0,0,2.09-6.84q0-4.52-2-7A6.87,6.87,0,0,0,381.21,40Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M413.41,61.93h-4.08V51.78q0-5-3.56-5a3.87,3.87,0,0,0-3.08,1.4,5.16,5.16,0,0,0-1.21,3.52V61.93h-4.1v-18h4.1v3h.07a6.41,6.41,0,0,1,5.83-3.41,5.46,5.46,0,0,1,4.49,1.91,8.57,8.57,0,0,1,1.54,5.51Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M190.32,101.31q0,8.4-5,13.38-5.6,5.94-14.73,5.94a20.66,20.66,0,0,1-20.83-20.95A20.66,20.66,0,0,1,170.6,78.74,22.22,22.22,0,0,1,179,80.31a16.68,16.68,0,0,1,6.44,4.42l-3.7,3.7a12.31,12.31,0,0,0-4.78-3.5,15.87,15.87,0,0,0-6.31-1.26,15.08,15.08,0,0,0-11.08,4.53,16.95,16.95,0,0,0,0,23,16.1,16.1,0,0,0,21,1.18,13.44,13.44,0,0,0,4.6-9.24H170.6V98.28H190A18,18,0,0,1,190.32,101.31Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M193.84,106a14.51,14.51,0,0,1,4-10.47A13.58,13.58,0,0,1,208,91.39,13.38,13.38,0,0,1,218,95.54a15.62,15.62,0,0,1,0,20.94A13.35,13.35,0,0,1,208,120.63a13.54,13.54,0,0,1-10.14-4.15A14.51,14.51,0,0,1,193.84,106Zm5.16,0a10.08,10.08,0,0,0,2.57,7.17,8.81,8.81,0,0,0,12.77,0,11.17,11.17,0,0,0,0-14.28,8.68,8.68,0,0,0-12.77,0A10,10,0,0,0,199,106Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M225.21,106a14.5,14.5,0,0,1,4-10.47,13.58,13.58,0,0,1,10.14-4.15,13.38,13.38,0,0,1,10.08,4.15,15.62,15.62,0,0,1,0,20.94,13.35,13.35,0,0,1-10.08,4.15,13.54,13.54,0,0,1-10.14-4.15A14.5,14.5,0,0,1,225.21,106Zm5.15,0a10.08,10.08,0,0,0,2.57,7.17,8.81,8.81,0,0,0,12.77,0,11.17,11.17,0,0,0,0-14.28,8.68,8.68,0,0,0-12.77,0A10,10,0,0,0,230.36,106Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M270.29,132.72a15.09,15.09,0,0,1-4.32-.59,14,14,0,0,1-3.67-1.65,11.79,11.79,0,0,1-2.82-2.52,10.45,10.45,0,0,1-1.8-3.25l4.88-2a7.73,7.73,0,0,0,2.91,3.86,8.18,8.18,0,0,0,4.82,1.46,8.54,8.54,0,0,0,6.55-2.52,9.83,9.83,0,0,0,2.35-7v-2.63H279a10.1,10.1,0,0,1-3.94,3.45,11.83,11.83,0,0,1-5.41,1.26,12.14,12.14,0,0,1-9.24-4.2A15.2,15.2,0,0,1,256.56,106a15,15,0,0,1,3.81-10.36,12.07,12.07,0,0,1,9.24-4.26A11.83,11.83,0,0,1,275,92.65,10.1,10.1,0,0,1,279,96.1h.23V92.29h4.93v26.26q0,6.61-3.75,10.36A13.64,13.64,0,0,1,270.29,132.72Zm.16-16.8a7.9,7.9,0,0,0,6.22-2.74,11.37,11.37,0,0,0,0-14.28,7.92,7.92,0,0,0-6.22-2.8,8,8,0,0,0-6.21,2.8,10.24,10.24,0,0,0-2.52,7.11,10.1,10.1,0,0,0,2.52,7.11A8,8,0,0,0,270.45,115.92Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M295.54,79.63v40.1h-5.15V79.63Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M313.85,120.63a13.12,13.12,0,0,1-10-4.15A14.64,14.64,0,0,1,300,106a14.89,14.89,0,0,1,3.81-10.44,13.68,13.68,0,0,1,19.46-.23q3.61,3.94,3.61,11.06l0,.56H305.23a8.91,8.91,0,0,0,2.69,6.5,8.59,8.59,0,0,0,6.16,2.46q4.92,0,7.72-4.93l4.6,2.24a13.72,13.72,0,0,1-5.13,5.44A14.2,14.2,0,0,1,313.85,120.63Zm-8.23-17.92h15.74A6.87,6.87,0,0,0,319,98a8.13,8.13,0,0,0-5.63-1.87,7.49,7.49,0,0,0-5,1.79A8.58,8.58,0,0,0,305.62,102.71Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M349.92,103.49v16.24h-5.16V79.63h13.67a12.34,12.34,0,0,1,8.85,3.48,11.59,11.59,0,0,1,0,17,12.33,12.33,0,0,1-8.85,3.42Zm0-18.93v14h8.62a6.84,6.84,0,0,0,5.1-2.07,7,7,0,0,0-5.1-11.93Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M380.88,79.63v40.1h-5.15V79.63Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M397.29,91.39q5.71,0,9,3.06a10.83,10.83,0,0,1,3.3,8.37v16.91h-4.93v-3.81h-.22a9.83,9.83,0,0,1-8.51,4.71,11.06,11.06,0,0,1-7.59-2.69,8.56,8.56,0,0,1-3.05-6.72,8.15,8.15,0,0,1,3.22-6.78,13.55,13.55,0,0,1,8.59-2.52,15.22,15.22,0,0,1,7.56,1.68v-1.17a5.86,5.86,0,0,0-2.13-4.57,7.3,7.3,0,0,0-5-1.87,7.89,7.89,0,0,0-6.83,3.64l-4.54-2.86Q390,91.4,397.29,91.39Zm-6.66,19.94a4.14,4.14,0,0,0,1.7,3.36,6.28,6.28,0,0,0,4,1.34,8.22,8.22,0,0,0,5.79-2.4,7.55,7.55,0,0,0,2.55-5.66,10.56,10.56,0,0,0-6.72-1.9,8.7,8.7,0,0,0-5.23,1.51A4.49,4.49,0,0,0,390.63,111.33Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M439.4,92.29l-17.19,39.54h-5.32L423.27,118,412,92.29h5.6L425.74,112h.11l7.95-19.71Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlaystore);
export default __webpack_public_path__ + "static/media/icon_playstore.0932621b77a366ea1bee0a13fc9aa525.svg";
export { ForwardRef as ReactComponent };